import React from 'react'
import { Flex } from '@jisr-hr/design-system'
import { useDispatch } from 'react-redux'
import JisrLoader from 'components/global/JisrLoader'
import { createDelegationRequests } from 'redux/leaves/DelegationRequest/actionsCreator'
import { DelegationDetails, Reason, Profile } from '../../components/forms'
import { useRequest } from '../../RequestProvider'

const DelegationRequest = () => {
  const dispatch = useDispatch()
  const {
    setInitialValues,
    setOnSubmit,
    vars: { request, id, employee },
    drawerToggle,
    actionCallback,
  } = useRequest()

  const onSubmit = (val) => {
    return dispatch(createDelegationRequests(request?.employee?.id ?? id, val)).then(() => {
      drawerToggle()
      if (actionCallback) {
        actionCallback()
      }
    })
  }

  React.useEffect(() => {
    setOnSubmit(onSubmit)
    setInitialValues({})

    return () => {
      setOnSubmit(() => {})
      setInitialValues({})
    }
  }, [])

  return (
    <Flex
      flexCol
      style={{ gap: 16 }}
    >
      {false && <JisrLoader absolute />}
      <Profile employee={employee} />
      <DelegationDetails />

      <Reason />
    </Flex>
  )
}

export default DelegationRequest
